import { PUBNUB_PUBLISH_KEY, PUBNUB_SUBSCRIBE_KEY } from "@constants/env-variables";
import { getPubNubService } from "@stadium/services/pubnub";

export const getPubNubServiceInstance = getPubNubService({
  publishKey: PUBNUB_PUBLISH_KEY,
  subscribeKey: PUBNUB_SUBSCRIBE_KEY,
});
